// extracted by mini-css-extract-plugin
export default {"body":"Advantege_body__TKx1y","Img":"Advantege_Img__AnX7h","text":"Advantege_text__XPWk-"};